import {Transaction} from "../Transaction";

type PartialTransaction = Pick<Transaction, 'transferToAccountUUID'>

const isTransfer = (t: PartialTransaction) => t.transferToAccountUUID !== null;

export default isTransfer;